/* Alya bloating + liver landing page: gallery, supply tabs, purchase option and
   add to cart. Adds through the theme's cart drawer when it is present, else
   through /cart/add.js and on to /cart. */
(function () {
  function init(root) {
    if (root.dataset.ablReady) return;
    root.dataset.ablReady = '1';
    var dataEl = root.querySelector('[data-abl-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : {};
    var form = root.querySelector('[data-abl-form]');
    var idInput = root.querySelector('[data-abl-id]');
    var planInput = root.querySelector('[data-abl-plan]');
    var subBox = root.querySelector('[data-abl-sub-box]');
    var modes = root.querySelectorAll('[data-abl-mode]');
    var addBtn = root.querySelector('[data-abl-add]');
    var errorEl = root.querySelector('[data-abl-error]');

    // Gallery
    root.querySelectorAll('[data-abl-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var n = btn.getAttribute('data-abl-thumb');
        root.querySelectorAll('[data-abl-slide]').forEach(function (img) {
          img.hidden = img.getAttribute('data-abl-slide') !== n;
          if (!img.hidden) img.loading = 'eager';
        });
        root.querySelectorAll('[data-abl-thumb]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
      });
    });
    var closeBtn = root.querySelector('[data-abl-badge-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () {
      var badge = root.querySelector('[data-abl-badge]');
      if (badge) badge.hidden = true;
    });

    function mode() {
      var m = 'onetime';
      modes.forEach(function (r) { if (r.checked) m = r.value; });
      return m;
    }

    function render() {
      var v = variants[idInput.value];
      if (!v) return;
      var hasPlan = !!v.plan;
      subBox.hidden = !hasPlan;
      if (!hasPlan) modes.forEach(function (r) { r.checked = r.value === 'onetime'; });
      root.querySelector('[data-abl-sub-price]').textContent = v.sub_price;
      root.querySelector('[data-abl-sub-list]').textContent = hasPlan ? 'list ' + v.list : '';
      root.querySelector('[data-abl-sub-pct]').textContent = v.sub_pct ? v.sub_pct + '% OFF' : '';
      root.querySelector('[data-abl-one-price]').textContent = v.price;
      root.querySelector('[data-abl-one-per]').textContent = v.per_bottle ? v.per_bottle + ' / bottle' : '';
      planInput.value = mode() === 'subscribe' && hasPlan ? v.plan : '';
      planInput.disabled = !planInput.value;
    }

    function selectVariant(id) {
      idInput.value = id;
      root.querySelectorAll('[data-abl-variant]').forEach(function (b) {
        b.setAttribute('aria-checked', b.getAttribute('data-abl-variant') === String(id) ? 'true' : 'false');
      });
      render();
    }

    root.querySelectorAll('[data-abl-variant]').forEach(function (b) {
      b.addEventListener('click', function () { selectVariant(b.getAttribute('data-abl-variant')); });
    });
    root.querySelectorAll('[data-abl-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var name = tab.getAttribute('data-abl-tab');
        root.querySelectorAll('[data-abl-tab]').forEach(function (t) {
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        var shown = null;
        root.querySelectorAll('[data-abl-group]').forEach(function (g) {
          g.hidden = g.getAttribute('data-abl-group') !== name;
          if (!g.hidden) shown = g;
        });
        if (shown && !shown.querySelector('[aria-checked="true"]')) {
          var packs = shown.querySelectorAll('[data-abl-variant]:not([disabled])');
          if (packs.length) selectVariant(packs[0].getAttribute('data-abl-variant'));
        }
      });
    });
    modes.forEach(function (r) { r.addEventListener('change', render); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      render();
      errorEl.hidden = true;
      addBtn.disabled = true;
      var item = { id: Number(idInput.value), quantity: 1 };
      if (planInput.value) item.selling_plan = Number(planInput.value);
      var done;
      if (window.OdditCartDrawer && typeof window.OdditCartDrawer.addMultipleToCart === 'function') {
        done = window.OdditCartDrawer.addMultipleToCart([item]);
      } else {
        done = fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); });
          window.location.href = '/cart';
        });
      }
      Promise.resolve(done).catch(function (err) {
        errorEl.textContent = (err && err.message) || 'Could not add to cart. Please try again.';
        errorEl.hidden = false;
      }).then(function () { addBtn.disabled = false; });
    });

    render();
  }

  function boot() { document.querySelectorAll('[data-abl-buy]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
